import React, { useState } from "react";

// components
import { Grid } from "@mui/material";
import PlanItemDish from "./PlanItemDish";

const PlanItemDishes = (props) => {
  const { item, onSet, units, dishes: allDishes } = props;

  const [dishes, setDishes] = useState(item.dishes);

  const addDish = () => {
    setDishes([
      ...dishes,
      {
        id: -1 * (dishes.length + 1),
        amount: "",
        unit: "",
      },
    ]);
  };

  const removeDish = (dish) => {
    setDishes(
      dishes.filter((d, idx) => {
        if (d.id === dish.id) return false;

        if (d.id < 0) {
          d.id = -1 * (idx + 1);
        }

        return true;
      })
    );
  };

  const updateDishes = (dish, index) => {
    const newDishes = dishes.map((d, i) => {
      if (i === index) return dish;

      return d;
    });
    setDishes(newDishes);
    onSet(item, "dishes", newDishes);
  };

  return (
    <Grid container spacing={1}>
      {dishes.map((dish, index) => (
        <PlanItemDish
          key={`dish-${index}`}
          first={index === 0}
          last={index === dishes.length - 1}
          item={item}
          dish={dish}
          dishes={allDishes}
          units={units}
          onSet={onSet}
          onAddDish={addDish}
          onRemoveDish={removeDish}
          onChange={(dish) => updateDishes(dish, index)}
        />
      ))}
    </Grid>
  );
};

export default PlanItemDishes;
